// Thin horizontal bars with the label, figure and (optionally) a second
// figure on the same line. HTML rather than a chart lib: rows stay legible
// and clickable at any width.
const BarList = ({ rows = [], onRowClick }) => {
  const max = Math.max(...rows.map((r) => r.value), 0);

  return (
    <div className="crm-barlist">
      {rows.map((r) => {
        const pct = max > 0 ? Math.max((r.value / max) * 100, r.value > 0 ? 3 : 0) : 0;
        const clickable = !!onRowClick && !r.static;
        return (
          <div
            key={r.key}
            className={`crm-barlist-row${clickable ? " clickable" : ""}`}
            onClick={clickable ? () => onRowClick(r) : undefined}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={
              clickable
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") onRowClick(r);
                  }
                : undefined
            }
          >
            <div className="crm-barlist-line">
              <span className="crm-barlist-label">{r.label}</span>
              <span className="crm-barlist-figures">
                {r.secondary && <span className="crm-barlist-secondary">{r.secondary}</span>}
                <b>{r.display ?? r.value}</b>
              </span>
            </div>
            <div className="crm-barlist-track">
              <div
                className="crm-barlist-fill"
                style={{ width: `${pct}%`, background: r.color }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BarList;
